export default function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/zero-fill.js
// module id = 43
// module chunks = 0